<template>
  <div></div>
</template>
    
<script>
export default {
  name: "ListAddressesView",
  components: {},
};
</script>